export default __webpack_public_path__ + "static/media/frequency slider for sound.46d8ced2.svg";